module.exports = __webpack_public_path__ + "static/img/17.024d4a22.png";